import { useI18n } from '@nx/i18n';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  partnerLoadRequested,
  partnerLogCreateRequested,
  partnerLogsWatchRequested,
  partnerUpdateRequested,
} from '../../store/slices/partnersSlice';
export function PartnerDetailPage() {
  const { t } = useI18n();
  const { eventId = '', partnerId = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const partner = useAppSelector((s) => s.partners.current);
  const logs = useAppSelector((s) => s.partners.logs);
  const [tab, setTab] = useState<'info' | 'contract' | 'log'>('info');
  const [logText, setLogText] = useState('');

  useEffect(() => {
    dispatch(partnerLoadRequested({ eventId, partnerId }));
    dispatch(partnerLogsWatchRequested({ eventId, partnerId }));
  }, [dispatch, eventId, partnerId]);

  if (!partner) return <p>{t('common.loading')}</p>;

  return (
    <>
      <p className="eo-bar-crumb">
        <button type="button" className="subtle-link" onClick={() => navigate(`/eo/events/${eventId}/partners`)}>
          {t('eo.nav.partners')}
        </button>
        <span className="sep">›</span>
        {partner.companyName}
      </p>

      <div className="tabs">
        <button type="button" className={`tab ${tab === 'info' ? 'on' : ''}`} onClick={() => setTab('info')}>
          {t('eo.partners.tabInfo')}
        </button>
        <button type="button" className={`tab ${tab === 'contract' ? 'on' : ''}`} onClick={() => setTab('contract')}>
          {t('eo.partners.tabContract')}
        </button>
        <button type="button" className={`tab ${tab === 'log' ? 'on' : ''}`} onClick={() => setTab('log')}>
          {t('eo.partners.tabLog')}
        </button>
      </div>

      {tab === 'info' ? (
        <div className="card card-pad-lg">
          <div className="field">
            <label>{t('eo.partners.company')}</label>
            <input
              className="input"
              defaultValue={partner.companyName}
              onBlur={(e) =>
                dispatch(
                  partnerUpdateRequested({
                    eventId,
                    partnerId,
                    input: { companyName: e.target.value },
                  }),
                )
              }
            />
          </div>
          <div className="field">
            <label>{t('eo.partners.contact')}</label>
            <input className="input" defaultValue={partner.contactName ?? ''} />
          </div>
          <p className="muted-text">{partner.collaborationContent}</p>
        </div>
      ) : null}

      {tab === 'contract' ? (
        <div className="card card-pad-lg">
          <div className="field">
            <label>{t('eo.partners.contractDue')}</label>
            <input
              type="date"
              className="input"
              defaultValue={partner.contractDueDate?.toISOString().slice(0, 10) ?? ''}
              onBlur={(e) =>
                dispatch(
                  partnerUpdateRequested({
                    eventId,
                    partnerId,
                    input: { contractDueDate: e.target.value ? new Date(e.target.value) : null },
                  }),
                )
              }
            />
          </div>
          <div className="field">
            <label>{t('eo.partners.amount')}</label>
            <input className="input" defaultValue={partner.monetaryAmount?.toString() ?? ''} />
          </div>
        </div>
      ) : null}

      {tab === 'log' ? (
        <div className="card card-pad-lg">
          <div className="field">
            <label>{t('eo.partners.addLog')}</label>
            <textarea className="textarea" rows={3} value={logText} onChange={(e) => setLogText(e.target.value)} />
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              dispatch(partnerLogCreateRequested({ eventId, partnerId, content: logText }));
              setLogText('');
            }}
          >
            {t('common.submit')}
          </button>
          <div style={{ marginTop: 20 }}>
            {logs.map((l) => (
              <div key={l.id} style={{ borderBottom: '1px solid var(--border)', padding: '12px 0' }}>
                <p style={{ margin: 0 }}>{l.content}</p>
                <small className="muted-text">{l.createdAt?.toLocaleString()}</small>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
